import { SizeType } from '@payflip/types/product-builder';
import { formatDate } from '@payflip/utils';
import { useNavigate } from 'react-router';
import { Amount, GraySpan, ImageWrapper } from '../../_atoms';
import { Heading } from '../../heading';
import { IconName } from '../../icons';
import { LinkButton } from '../../link-button';
import { Paragraph } from '../../paragraph';
import { Tooltip } from '../../tooltip';
import { StyledTransactionRow, StyledTransactionRowItem } from './styled';

export type TransactionRowProps = {
  title: string;
  date: Date | string;
  amount: number;
  icon?: JSX.Element;
  description?: string;
  infoMessage?: JSX.Element | string;
  extraDescription?: string;
  isPaymentOrder?: boolean;
  detailUrl?: string;
};

export function TransactionRow({
  icon,
  title,
  date,
  description,
  amount,
  infoMessage,
  extraDescription,
  isPaymentOrder,
  detailUrl
}: TransactionRowProps): JSX.Element {
  const navigate = useNavigate();

  return (
    <StyledTransactionRow
      clickable={!!detailUrl}
      onClick={(): void => {
        detailUrl && navigate(detailUrl);
      }}
    >
      <StyledTransactionRowItem>
        {icon && <ImageWrapper>{icon}</ImageWrapper>}
        <div>
          <Heading variant="h5">{title}</Heading>
          <span>{formatDate(date)}</span>
        </div>
      </StyledTransactionRowItem>

      <StyledTransactionRowItem align="right">
        <div>
          {infoMessage ? (
            <StyledTransactionRowItem hasTooltip>
              <Paragraph variant="medium" bold>
                <Amount amount={amount} />
              </Paragraph>
              <Paragraph>
                <Tooltip title="Info" showRule="click">
                  {infoMessage}
                </Tooltip>
              </Paragraph>
            </StyledTransactionRowItem>
          ) : (
            <Paragraph variant="medium" bold>
              <Amount amount={amount} />
            </Paragraph>
          )}
          {description && <GraySpan>{description}</GraySpan>}
        </div>
        {extraDescription && (
          <Paragraph lighter variant="small" style={{ textAlign: 'right' }}>
            {extraDescription}
          </Paragraph>
        )}
        {isPaymentOrder && (
          <LinkButton
            size={SizeType.Small}
            iconPosition="left"
            icon={IconName.ArrowRight}
            variant="tertiary"
            internal
          />
        )}
      </StyledTransactionRowItem>
    </StyledTransactionRow>
  );
}
